export default function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-shape/src/order/none.js
// module id = GKxH
// module chunks = 0